import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { 
    Grid,
    Typography,
    Paper,
    IconButton
} from "@material-ui/core";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import moment from 'moment';

import AddButtonComprobante from '../UI/AddButtonComprobante';
import { useEffect } from 'react';
import { deleteComprobanteMesaEntrada, getExpedientes, postComprobanteMesaEntrada } from '../../../actions/mesaEntrada/mesaEntradaActions';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import ToolbarXLSPDF from '../../compartidos/ToolbarXLSPDF';
import { useRef } from 'react';
import DeleteButtonAbm from '../../compartidos/abms/DeleteButtonAbm';
import { StepperFormExpediente } from './StepperFormExpediente';
import { generateExcelMesaEntrada, generatePDFMesaEntrada } from '../../../actions/mesaEntrada/documentacionMesaEntradaActions';
import { MESA_ENTRADA_PERMISOS } from '../../../utils/permisos';
import { ESTADOS_COMRPOBANTES, TIPO_COMPROBANTE_DOCUMENTO } from '../../../utils/constants';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import IconEstado from '../../autorizaciones/UI/IconEstado';
import { ImpresionComprobante } from '../UI/ImpresionComprobante';

const validators = [
    "required",
    "minStringLength:10",
    "maxStringLength:100"
];
const errorMessages = [
    "Debe ingresar un motivo de baja",
    "El motivo de baja debe tener al menos 10 caracteres",
    "El motivo de baja no debe tener más de 100 caracteres"
];

export const ComprobantesDocumentos = () => {
    const dispatch = useDispatch();

    const { permisos:permisosUser } = useSelector(state => state.auth);
    const { comprobantes, tipoComprobanteDocumentoMenu } = useSelector(state => state.mesaEntrada);
    const menuEmbargo = tipoComprobanteDocumentoMenu === TIPO_COMPROBANTE_DOCUMENTO.EMBARGO;

    const [motivoBaja, setMotivoBaja] = useState({
        active: true,
        text: ""
    });

    const componentRef = useRef();

    const handleSave = (formValues, stepperMenu) => {
        dispatch(postComprobanteMesaEntrada(formValues, stepperMenu));
    }

    const handleDelete = (idExpediente) => {
        dispatch(deleteComprobanteMesaEntrada({idExpediente, motivoBaja: motivoBaja.text}));
    };

    useEffect(() => {
        if(comprobantes.length === 0)
            dispatch(getExpedientes());
    }, []);

    return (
        <Grid
            container
            spacing={1}
            direction="row"
            justify="center"
            alignItems="center"
        >
            <Grid item xs={12} md={11} style={{paddingLeft:0, marginBottom:10}}>
                <AddButtonComprobante
                    title="Agregar Comprobante"
                    handleSave={handleSave}
                    permiso={MESA_ENTRADA_PERMISOS.ALTA}
                    form={StepperFormExpediente}
                />
            </Grid>
            <Grid item xs={12} md={11} style={{paddingLeft:0, marginBottom:20}}>
                <Grid container justify="space-between" alignItems="center" component={Paper} spacing={2}>
                    <Grid item >
                        <Typography variant="subtitle1" style={{ paddingLeft: 20 }}>
                            Listado de Comprobantes Documentos
                        </Typography>
                    </Grid>
                    <Grid item>
                        <ToolbarXLSPDF
                            handleExportExcel={() => dispatch(generateExcelMesaEntrada())}
                            handleGeneratePdf={() => dispatch(generatePDFMesaEntrada())}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TableGeneric
                            ref={componentRef}
                            data={comprobantes}
                            withoutPagination
                            align="center"
                            columns={menuEmbargo ? [
                                {
                                    label: "Elimnar comprobante",
                                    customBody: (item) => (
                                        <>
                                            {   item.idEstado === ESTADOS_COMRPOBANTES.PENDIENTE_ENVIO ||
                                                item.idEstado === ESTADOS_COMRPOBANTES.RETORNADA ||
                                                validarSoloUnPermiso(permisosUser, MESA_ENTRADA_PERMISOS.BAJA) ? (
                                                <DeleteButtonAbm
                                                    handleDelete={() => handleDelete(item.idExpediente)}
                                                    permiso={MESA_ENTRADA_PERMISOS.BAJA}
                                                    mensajeEliminacion="¿Desea anular este comprobante?"
                                                    motivo={motivoBaja}
                                                    setMotivo={setMotivoBaja}
                                                    validators={validators}
                                                    errorMessages={errorMessages}
                                                />
                                            ) : (
                                                <IconButton
                                                    aria-label="Eliminar"
                                                    disabled
                                                >
                                                    <DeleteForeverIcon sx={{ fontSize: "2rem" }} />
                                                </IconButton>
                                            )}
                                        </>
                                    )
                                },
                                {
                                    label: "Estado comprobante",
                                    customBody: (item) => (
                                        <IconEstado
                                            useColorTable={true}
                                            texto={item?.letra}
                                            backgroundColor={item?.color}
                                            descripcion={item?.descripcionEstado}
                                        />
                                    )
                                },
                                {
                                    label: "Fecha Ingreso",
                                    id: "fechaCarga",
                                    customBody: (item) => moment(item.fechaCarga).format("DD/MM/YYYY"),
                                    sort: true
                                },
                                {
                                    label: "Id Comprobante",
                                    id: "idExpediente",
                                    sort: true
                                },
                                {
                                    label: "Fecha Recepcion",
                                    id: "fechaRecepcion",
                                    customBody: (item) => moment(item.fechaRecepcion).format("DD/MM/YYYY"),
                                    sort: true
                                },
                                {
                                    label: "Procedencia",
                                    id: "descripcionProcedencia",
                                },
                                {
                                    label: "Cuit",
                                    id: "cuit"
                                },
                                {
                                    label: "CBU Embargo",
                                    id: "cbuEmbargo"
                                },
                                {
                                    label: "Auto Documento",
                                    id: "autos"
                                },
                                {
                                    label: "Importe",
                                    id: "importe",
                                    customBody: (item) => `$ ${parseFloat(item.importe).toFixed(2)}`,
                                },
                                {
                                    label: "Imprimir Comprobante",
                                    customBody: (item) => (
                                        <ImpresionComprobante comprobante={item} documento />
                                    )
                                }
                            ] : [
                                {
                                    label: "Elimnar Comprobante",
                                    customBody: (item) => (
                                        <>
                                            {(item.idEstado === ESTADOS_COMRPOBANTES.PENDIENTE_ENVIO || item.idEstado === ESTADOS_COMRPOBANTES.RETORNADA) &&
                                             validarSoloUnPermiso(permisosUser, MESA_ENTRADA_PERMISOS.BAJA) ? (
                                                    <DeleteButtonAbm
                                                        handleDelete={() => handleDelete(item.idExpediente)}
                                                        permiso={MESA_ENTRADA_PERMISOS.BAJA}
                                                        mensajeEliminacion="¿Desea anular este comprobante?"
                                                        motivo={motivoBaja}
                                                        setMotivo={setMotivoBaja}
                                                        validators={validators}
                                                        errorMessages={errorMessages}
                                                    />
                                                ) : (
                                                    <IconButton
                                                        aria-label="Eliminar"
                                                        disabled
                                                    >
                                                        <DeleteForeverIcon sx={{ fontSize: "2rem" }} />
                                                    </IconButton>
                                                )
                                            }
                                        </>
                                    )
                                },
                                {
                                    label: "Estado Comprobante",
                                    customBody: (item) => (
                                        <IconEstado
                                            useColorTable={true}
                                            texto={item?.letra}
                                            backgroundColor={item?.color}
                                            descripcion={item?.descripcionEstado}
                                        />
                                    )
                                },
                                {
                                    label: "Fecha Ingreso",
                                    id: "fechaCarga",
                                    customBody: (item) => moment(item.fechaCarga).format("DD/MM/YYYY"),
                                    sort: true
                                },
                                {
                                    label: "Id Comprobante",
                                    id: "idExpediente",
                                    sort: true
                                },
                                {
                                    label: "Id Comprobante SV",
                                    id: "idExpedientes",
                                    sort: true
                                },
                                {
                                    label: "Fecha Recepcion",
                                    id: "fechaRecepcion",
                                    customBody: (item) => moment(item.fechaRecepcion).format("DD/MM/YYYY"),
                                    sort: true
                                },
                                {
                                    label: "Procedencia",
                                    id: "descripcionProcedencia",
                                },
                                {
                                    label: "Fecha Carta",
                                    id: "fechaCarta",
                                    customBody: (item) => moment(item.fechaCarta).format("DD/MM/YYYY"),
                                },
                                {
                                    label: "Carátula",
                                    id: "caratula"
                                },
                                {
                                    label: "Entregado por",
                                    id: "entregadoPor"
                                },
                                {
                                    label: "Folios",
                                    id: "folios"
                                },
                                {
                                    label: "Imprimir Comprobante",
                                    customBody: (item) => (
                                        <ImpresionComprobante comprobante={item} documento />
                                    )
                                }
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>   
    )
}
